import React, { Component } from 'react';
import Resources    from './Resources';
import Settings    from './CanvasSettings';
import _ from 'lodash';

export default class Sizes extends Component {

	constructor(props) {
		super(props);

		this.state = { }; 
	}

	render() {
        const boxStyle = {
            width: 350,
            height: 350,
            display: 'inline-block',
            border: 'rgba(0,0,0,0.2) 1px solid',
            position: 'relative',
            userSelect: 'initial',
            verticalAlign: 'middle'
        }
        const labelStyle = {
            position: 'absolute',
            display: 'block',
            bottom: 0,
            left: 0,
            background:'#2184b8',
            fontSize: '9px',
            width: '100%',
            fontFamily: 'arial',
	        fontWeight: 'normal',
            marginBottom: 0
        }

        const mapp = (elems) => {
            return elems.map((item, key) => {
                let size = 4;
                Settings.cellWidth  = 30;
                Settings.cellHeight = 30;

                let imageStyle = {
                    position: 'absolute',
                    transform: 'translate(-50%,-50%)',
                    top: '50%',
                    left: '50%',
                    maxWidth  : Settings.cellWidth  * size,
                    maxHeight : Settings.cellHeight * size
                }

                var parts = item.src.split('/');

                return <div key={key} style={boxStyle}>
                    <img src={'img/element/' + item.src} style={imageStyle} role="presentation"/>
                    <label style={labelStyle}>
                        {parts[1]}
                        <br/>
                        Size: {size[0]}
                    </label>
                </div>

            });
        }

		return (
			<div className="home" onClick={this.onClick} onContextMenu={this.onContextMenu} style={{background:'#009ba8', height: 'auto'}}>
				
                <div style={{textAlign:'center'}}>
                    <h1>Construcciones</h1>
                    {mapp(Resources.buildings)}

                    <h1>Naturaleza</h1>
                    {mapp(Resources.nature)}

                    <h1>Personajes</h1>
                    {mapp(Resources.characters)}
                </div>
				
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Sizes.js